import { render, staticRenderFns } from "./JobOpportunitiesPage.vue?vue&type=template&id=1bf9d0aa&"
import script from "./JobOpportunitiesPage.vue?vue&type=script&lang=js&"
export * from "./JobOpportunitiesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports